import React, { useState, useEffect, useRef } from "react";
import { ExternalLink, Loader2 } from "lucide-react";

export default function FacebookEmbed({ url }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        obs.disconnect();
      }
    }, { rootMargin: "300px" });
    obs.observe(node);
    return () => obs.disconnect();
  }, []);

  const isVideo = /\/(videos|reel|watch)\//i.test(url) || /\/watch\?/i.test(url);
  const plugin = isVideo ? "video.php" : "post.php";
  const src = `https://www.facebook.com/plugins/${plugin}?href=${encodeURIComponent(url)}&show_text=true&width=500&adapt_container_width=true`;

  return (
    <div ref={ref} className="bg-white border border-gray-200 flex flex-col overflow-hidden">
      <div className="flex-1 min-h-[420px] flex items-center justify-center bg-[#FAFAFA]">
        {visible ? (
          <iframe src={src} title={`Facebook post: ${url}`} loading="lazy" scrolling="no"
            className="w-full h-[500px] border-0 overflow-hidden bg-white"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen />
        ) : (
          <Loader2 className="w-6 h-6 text-gray-300 animate-spin" />
        )}
      </div>
      <a href={url} target="_blank" rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 border-t border-gray-200 py-3 font-tech font-semibold uppercase tracking-widest text-xs text-[#171717] hover:text-[#E4001C] transition-colors">
        View on Facebook <ExternalLink className="w-3.5 h-3.5" />
      </a>
    </div>
  );
}